// src/types/field-state.ts
function createInitialFieldState(value) {
  return {
    value,
    dirty: false,
    touched: false,
    validity: "unknown",
    errors: []
  };
}

// src/types/form-spec-internals.ts
var _FORMSPEC_METADATA_POLICY = /* @__PURE__ */ Symbol.for("@formspec/core/FormSpec.metadataPolicy");
function _attachFormSpecMetadataPolicy(form, metadataPolicy) {
  if (metadataPolicy === void 0) {
    return form;
  }
  const nextForm = { ...form };
  Object.defineProperty(nextForm, _FORMSPEC_METADATA_POLICY, {
    value: metadataPolicy,
    enumerable: false,
    configurable: false,
    writable: false
  });
  return nextForm;
}
function _getFormSpecMetadataPolicy(form) {
  return form[_FORMSPEC_METADATA_POLICY];
}

// src/types/constraint-definitions.ts
var _BUILTIN_CONSTRAINT_DEFINITIONS = {
  minimum: "number",
  maximum: "number",
  exclusiveMinimum: "number",
  exclusiveMaximum: "number",
  multipleOf: "number",
  minLength: "number",
  maxLength: "number",
  minItems: "number",
  maxItems: "number",
  uniqueItems: "boolean",
  pattern: "string",
  const: "json",
  enumOptions: "json"
};
function _normalizeConstraintTagName(tagName) {
  return tagName.charAt(0).toLowerCase() + tagName.slice(1);
}
function _isBuiltinConstraintName(tagName) {
  return Object.hasOwn(_BUILTIN_CONSTRAINT_DEFINITIONS, tagName);
}

// src/types/ir.ts
var IR_VERSION = "0.1.0";

// src/extensions/index.ts
function defineExtension(def) {
  return def;
}
function defineCustomType(reg) {
  return reg;
}
function defineConstraint(reg) {
  return reg;
}
function defineConstraintTag(reg) {
  return reg;
}
function defineMetadataSlot(reg) {
  return reg;
}
function defineAnnotation(reg) {
  return reg;
}

// src/guards.ts
function isField(element) {
  return element._type === "field";
}
function isTextField(element) {
  return element._type === "field" && element._field === "text";
}
function isNumberField(element) {
  return element._type === "field" && element._field === "number";
}
function isBooleanField(element) {
  return element._type === "field" && element._field === "boolean";
}
function isStaticEnumField(element) {
  return element._type === "field" && element._field === "enum";
}
function isDynamicEnumField(element) {
  return element._type === "field" && element._field === "dynamic_enum";
}
function isDynamicSchemaField(element) {
  return element._type === "field" && element._field === "dynamic_schema";
}
function isArrayField(element) {
  return element._type === "field" && element._field === "array";
}
function isObjectField(element) {
  return element._type === "field" && element._field === "object";
}
function isGroup(element) {
  return element._type === "group";
}
function isConditional(element) {
  return element._type === "conditional";
}
export {
  _BUILTIN_CONSTRAINT_DEFINITIONS as BUILTIN_CONSTRAINT_DEFINITIONS,
  IR_VERSION,
  _BUILTIN_CONSTRAINT_DEFINITIONS,
  _FORMSPEC_METADATA_POLICY,
  _attachFormSpecMetadataPolicy,
  _getFormSpecMetadataPolicy,
  _isBuiltinConstraintName,
  _normalizeConstraintTagName,
  createInitialFieldState,
  defineAnnotation,
  defineConstraint,
  defineConstraintTag,
  defineCustomType,
  defineExtension,
  defineMetadataSlot,
  isArrayField,
  isBooleanField,
  _isBuiltinConstraintName as isBuiltinConstraintName,
  isConditional,
  isDynamicEnumField,
  isDynamicSchemaField,
  isField,
  isGroup,
  isNumberField,
  isObjectField,
  isStaticEnumField,
  isTextField,
  _normalizeConstraintTagName as normalizeConstraintTagName
};
//# sourceMappingURL=internals.js.map